export const leftStepDescriptions = [
  "Dados pessoais",
  "Dados da Empresa",
  "Tipo",
  "Orçamento",
  "Detalhes",
] as const;

export const sectionStepTitles = [
  "Dados pessoais",
  "Dados da empresa",
  "Tipo do projeto",
  "Orçamento",
  "Detalhes do projeto",
] as const;

export const proposalFieldClassName =
  "h-[52px] rounded-[8px] border-0 bg-[#202020] px-5 font-manrope text-[14px] leading-6 text-white shadow-none placeholder:text-[#dcdcdc] focus-visible:ring-1 focus-visible:ring-white/15";

export const proposalChoiceGroupClassName =
  "flex items-center gap-2 justify-between";
